import React from 'react';
import {
    Spinner,
    SpinnerBackgroundColors,
    SpinnerColors,
    SpinnerSizes,
    SpinnerTypeOptions
} from '@techsee/techsee-ui-common/lib/spinner';

interface GalleryLoaderProps {
    id: string;
}

export const GalleryLoader: React.FC<GalleryLoaderProps> = ({id}) => (
    <div key={id} className='gallery-image-live-spinner use-common-styles'>
        <Spinner
            spinnerType={SpinnerTypeOptions.CIRCULAR}
            sizeName={SpinnerSizes.Small}
            backgroundColorName={SpinnerBackgroundColors.Transparent}
            colorName={SpinnerColors.White}
        />
    </div>
);
